import { createContext, useContext } from 'react';

const TodayResetContext = createContext(null);

export function useResetRegistrar() {
  return useContext(TodayResetContext)?.registerReset;
}

export function useTodayReset() {
  return useContext(TodayResetContext)?.resetToToday;
}

export default TodayResetContext;
